import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/activity')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/messages',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
